import React from 'react';

import { Button, Icon } from '@sravni/react-design-system';
import { Trash } from '@sravni/react-icons';
import { useBoolean } from '@sravni/react-utils';

import { ENTITY_LABELS, ENTITY_TYPE } from '../../constants/reviews';

import { ActionDialog } from './Dialog';

interface IProps {
  onDelete?: () => void;
  type?: ENTITY_TYPE;
  onlyIcon?: boolean;
}

export const DeleteReview: React.FC<IProps> = ({ onDelete, type = ENTITY_TYPE.REVIEW, onlyIcon }) => {
  const [showDeleteDialog, setShowDeleteDialog] = useBoolean(false);

  return (
    <>
      <Button size={36} color={'red'} variant={onlyIcon ? 'outlined' : 'text'} onClick={() => setShowDeleteDialog.on()}>
        <Icon size={20} icon={<Trash />} />
        {!onlyIcon && `Удалить ${ENTITY_LABELS[type]}`}
      </Button>

      {showDeleteDialog && onDelete && (
        <ActionDialog
          title={`Удалить ${ENTITY_LABELS[type]}?`}
          showDialog={showDeleteDialog}
          onClose={() => setShowDeleteDialog.off()}
          onConfirm={onDelete}
        />
      )}
    </>
  );
};
